var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"text-center copyright"},[_c('img',{attrs:{"src":"static/assets/images/logo_mkcl.png","alt":"MKCL"}}),_vm._v(" "),_c('span',[_vm._v("© "+_vm._s(_vm.$t(_vm.footerBar.lblOrgnization)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.footerBar.lblPowerdBy)))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5e9e8a","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/mfs-footer.vue
// module id = J+zz
// module chunks = 1